interface JobTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  jobType?: string | null;
}

const getTabsForJobType = (jobType?: string | null) => {
  // Insurance tabs
  if (jobType === "Insurance") {
    return [
      "Overview",
      "Photo Hub",
      "Measurement/Estimate",
      "Supplements",
      "Forms",
      "Team & Activity",
      "Contingency Forms",
      "Communications",
      "Production",
    ];
  }
  
  // Commercial tabs
  if (jobType === "Commercial") {
    return [
      "Overview",
      "Photo Hub",
      "Quick Estimate",
      "Proposals",
      "Forms",
      "Team & Activity",
      "Communications",
      "Production",
    ];
  }
  
  // Retail tabs
  return [
    "Overview",
    "Photo Hub",
    "Measurement/Estimate",
    "Proposals",
    "Forms",
    "Team & Activity",
    "Communications",
    "Production",
  ];
};

export const JobTabs = ({ activeTab, onTabChange, jobType }: JobTabsProps) => {
  const tabs = getTabsForJobType(jobType);
  return (
    <div className="border-b border-border/50 bg-card/80 backdrop-blur-sm sticky top-0 z-10 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-center gap-2 sm:gap-4 overflow-x-auto scrollbar-hide py-4 sm:py-3">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={`px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold rounded-lg transition-all whitespace-nowrap flex-shrink-0 ${
                activeTab === tab
                  ? "bg-primary text-primary-foreground shadow-lg scale-105"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/60"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
